import { createFileRoute, Outlet, useParams } from "@tanstack/react-router"
import { SubPanelPortal } from "@/components/shell/sub-panel-slot"
import { RoomList } from "@/features/workplace/room-list"
import { requireCap } from "@/lib/route-guards"

export const Route = createFileRoute("/_app/workplace")({
  beforeLoad: requireCap("workplace"),
  component: WorkplaceLayout,
})

/** Workplace mode: room list in the sub-panel (sheet on mobile), page fills the canvas. */
function WorkplaceLayout() {
  const params = useParams({ strict: false }) as { roomId?: string }
  return (
    <>
      <SubPanelPortal>
        <RoomList activeId={params.roomId ? Number(params.roomId) : undefined} />
      </SubPanelPortal>
      <Outlet />
    </>
  )
}
